import {Application} from "pixi.js";

export default class DecodingModel
{
    private static _instance: DecodingModel = new DecodingModel();

    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Public:
    //----------------------------------
    public app:Application | undefined;
    public assets:any;
    public curDecodingIndex:number = 0;
    public curDecodingString:string = "";
    public fontFamily:string = "sweaterschoolreg";

    private _centerX:number = 0;
    private _centerY:number = 0;
    private _screenHeight:number = 0;
    private _screenWidth:number = 0;

    public get centerX():number
    {
        if(this._centerX == 0)
        {
            this._centerX = this.app!.screen.width/2;
        }
        return this._centerX;
    }

    public get centerY():number
    {
        if(this._centerY == 0)
        {
            this._centerY = this.app!.screen.height/2;
        }
        return this._centerY;
    }

    public get screenHeight():number
    {
        if(this._screenHeight == 0)
        {
            this._screenHeight = this.app!.screen.height;
        }
        return this._screenHeight;
    }

    public get screenWidth():number
    {
        if(this._screenWidth == 0)
        {
            this._screenWidth = this.app!.screen.width;
        }
        return this._screenWidth;
    }


    //--------------------------------------------------------------------------
    //
    //  Methods
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Public:
    //----------------------------------

    public static getInstance(): DecodingModel {
        return this._instance;
    }

}